import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@ui-seeker/app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import {
	isEditUserSettingsWebSupplierGroupDrawer,
	isLoadingUserSettingWebSupplierGroupData,
	userSettingsWebSupplierGroupFormData,
	userSettingWebSupplierGroupData,
} from "../@signals"


export default function useUserSettingsWebSupplierGroup(rowData = {}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getWebSupplierGroupData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/web_supplier_group`)
			.then(data => userSettingWebSupplierGroupData.value = data)
			.catch(() => {
				showToast.error()
				userSettingWebSupplierGroupData.value = []
			}).finally(() => isLoadingUserSettingWebSupplierGroupData.value = false)
	}, [])

	const handleSetFormData = useCallback(() => userSettingsWebSupplierGroupFormData.value = {
		id: rowData.id || null,
		service_type: SERVICES_TYPE.WEB_SUPPLIER_GROUP,
		name: rowData.name || "My Web Supplier Group",
		web_suppliers: rowData.web_suppliers || [],
	}, [JSON.stringify(rowData)])

	const handleChangeFormData = useCallback((newValue, prop) => userSettingsWebSupplierGroupFormData.value = {
		...userSettingsWebSupplierGroupFormData.value,
		[prop]: newValue,
	}, [])

	const handleSubmitFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(
			`${BACKEND_APIS.CRUD}/${!isEditUserSettingsWebSupplierGroupDrawer.value ? 'add' : 'update'}`,
			userSettingsWebSupplierGroupFormData.value
		).then(res => {
			if (isEditUserSettingsWebSupplierGroupDrawer.value) {
				userSettingWebSupplierGroupData.value = userSettingWebSupplierGroupData.value.map(
					item => item.id === userSettingsWebSupplierGroupFormData.value.id ? res : item
				)
			} else {
				userSettingWebSupplierGroupData.value = [...userSettingWebSupplierGroupData.value, res]
			}
			userSettingsWebSupplierGroupFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteRow = useCallback(() => showToast.confirm(
		`Are you sure you want to delete this row? This action cannot be undone.`,
		{
			onSubmit: () => {
				isLoading.value = true
				deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.WEB_SUPPLIER_GROUP}?id=${rowData.id}`)
					.then(() => {
						userSettingWebSupplierGroupData.value = userSettingWebSupplierGroupData.value.filter(
							item => item.id !== rowData.id
						)
					}).catch(() => showToast.error())
					.finally(() => isLoading.value = false)
			}
		}
	), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingsWebSupplierGroupFormData.value?.id,
		isLoading: isLoading.value,
		getWebSupplierGroupData,
		handleSetFormData,
		handleChangeFormData,
		handleSubmitFormData,
		handleDeleteRow,
	}
}